// extracted by mini-css-extract-plugin
module.exports = {"value":"text_group_list_value__2EFDE","editing":"text_group_list_editing__14V5m"};